import { Stack, Text, Image, UnstyledButton, Button, Center, Grid} from "@mantine/core"
import { Carousel } from '@mantine/carousel';
import { useRef, useState } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import { useMediaQuery, useTimeout, useViewportSize } from "@mantine/hooks";

function Offers(props) {
  
  const autoplay = useRef(Autoplay({ delay: 5000 }));
  const [slideIndex, setSlideIndex] = useState(0)
  const isMobile = useMediaQuery('(max-width: 900px)');

  const handleSlideChange = (index) => {
    setSlideIndex(index)
  }
  const { height, width } = useViewportSize()
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
//test
  return (

    <Stack>
    {isMobile ?
      <Carousel onSlideChange={handleSlideChange} maw={280} mx="auto" loop plugins={[autoplay.current]}
      onMouseEnter={autoplay.current.stop} withControls={props.offerList.length > 1}>
        {props.offerList.map((offerProduct) => {
          return (
            <Carousel.Slide key={offerProduct.variantId}>
              <Stack align={"center"}>
                <Image height={150} mx="auto" fit="contain" src={offerProduct.imageSrc} onClick></Image>
                <div mt={20} style={{textAlign: 'center'}}>
                  <Text>{offerProduct.title}</Text>
                  {/*<Text><span style={{color: "red"}}>{formatter.format(mainProduct.regularPrice)} </span><span style={{marginRight: "5px", textDecoration: "line-through"}}>{formatter.format(mainProduct.regularPrice)} + {formatter.format(offerProduct.regularPrice)}</span></Text>  */}
                  <Text m={8}>
                    <span style={{marginRight: "5px", textDecoration: "line-through"}}>{formatter.format(offerProduct.regularPrice)}</span>
                    <span style={{fontWeight: "bold", color: "white", background: "#189811", padding: "5px 12px", borderRadius: "5px"}}>{offerProduct.offerPrice === 0 ? "FREE" : formatter.format(offerProduct.offerPrice)}</span></Text>
                  <Text mt={30} size={"xs"}>1 promotion/discount code per order</Text>
                </div>
                
                <Button onClick={()=>{props.handleAddToCart(offerProduct, isMobile)}} pl={20} pr={20} pt={10} pb={10} style={{background: "black", color: "white", fontSize: "1rem"}} mt={-10}><span>ADD</span><span style={{marginLeft: "5px", marginRight: "5px", textDecoration: "underline"}}>{offerProduct.offerPrice === 0 ? "FREE" : formatter.format(offerProduct.offerPrice)}</span>{offerProduct.shortTitle.toUpperCase()} TO CART</Button>
                
              </Stack>
            </Carousel.Slide>
          )
        })}
      </Carousel>
    :
        <Grid justify="center">
        {props.offerList.map((offerProduct) => {
          return (
            <Grid.Col sm={4} lg={3} key={offerProduct.variantId}>
              <Stack align={"center"}>
                <Image height={150} mx="auto" fit="contain" src={offerProduct.imageSrc}></Image>
                <div mt={20} style={{textAlign: 'center'}}>
                  <Text>{offerProduct.title}</Text>
                  {/*<Text><span style={{color: "red"}}>{formatter.format(mainProduct.regularPrice)} </span><span style={{marginRight: "5px", textDecoration: "line-through"}}>{formatter.format(mainProduct.regularPrice)} + {formatter.format(offerProduct.regularPrice)}</span></Text>  */}
                  <Text m={8}>
                    <span style={{marginRight: "5px", textDecoration: "line-through"}}>{formatter.format(offerProduct.regularPrice)}</span>
                    <span style={{fontWeight: "bold", color: "white", background: "#189811", padding: "5px 12px", borderRadius: "5px"}}>{offerProduct.offerPrice === 0 ? "FREE" : formatter.format(offerProduct.offerPrice)}</span></Text>
                  <Text mt={20} size={"xs"}>1 promotion/discount code per order</Text>
                </div>
                
                <Button onClick={()=>{props.handleAddToCart(offerProduct, isMobile)}} pl={20} pr={20} pt={10} pb={10} style={{background: "black", color: "white", fontSize: "1rem"}} mt={-10}><span>ADD</span><span style={{marginLeft: "5px", marginRight: "5px", textDecoration: "underline"}}>{offerProduct.offerPrice === 0 ? "FREE" : formatter.format(offerProduct.offerPrice)}</span>{offerProduct.shortTitle.toUpperCase()} TO CART</Button>
                
              </Stack>
            </Grid.Col>
            
          )
        })}
        </Grid>
    }
    
    {/*<Group position="center">
    
    <UnstyledButton>
      <Image p={10} style={{borderRadius: "3px", border: "solid 1px " + (slideIndex === 0 ? "red": "black")}} width={100} height={100} fit="contain" mx="auto" src="https://cdn.shopify.com/s/files/1/0082/0907/2199/files/V2_cutout_web.png?v=1668489497"></Image>
    </UnstyledButton>
    <UnstyledButton>
      <Image p={10} style={{borderRadius: "3px", border: "solid 1px " + (slideIndex === 1 ? "red": "black")}} width={100} height={100} fit="contain" mx="auto" src="https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Horudo_5_Set_web.png?v=1667946123"></Image>
    </UnstyledButton>
    </Group>
    */}
    
    
    
    </Stack>

  )
}

export default Offers
